import React from 'react';
import loadercss from "../css/loader.module.css";


export default function Loader2(){
  return (
    <div className={loadercss.loaderOverlay}>
      <div
        className={`${loadercss.fullpageSpinner} ${loadercss.loader}`}
      />
    </div>
  );
};

